import React from 'react';
import { useAuth } from '../../../context/AuthContext';
import { SECTORS } from '../../../utils/sectors';

export default function WelcomeStep({ onNext }) {
  const { user } = useAuth();
  const firstName = user?.name?.split(' ')[0] || 'there';

  return (
    <div className="max-w-lg mx-auto text-center px-4 py-8">
      <p className="text-4xl mb-4">👋</p>
      <h1 className="font-serif text-2xl font-bold text-reset-brown mb-3">
        Welcome, {firstName}.
      </h1>
      <p className="text-gray-600 mb-6 leading-relaxed">
        Before the system can watch out for you, it needs to know you. We&apos;re going to build
        your <span className="font-semibold text-reset-terracotta">reset path</span> — your
        personal definition of what a balanced life looks and feels like.
      </p>
      <p className="text-gray-600 mb-8 leading-relaxed">
        This isn&apos;t a goal-setting exercise. You&apos;re not picking targets to hit. You&apos;re
        choosing a <em>range</em> — a comfort zone for each of your six health sectors. When
        your life drifts outside that range, the system notices and reaches out.
      </p>

      {/* Six sector preview */}
      <div className="grid grid-cols-3 gap-2 mb-8">
        {SECTORS.map(s => (
          <div key={s.key} className={`rounded-xl p-3 ${s.bgClass} text-center`}>
            <div className="text-xl mb-1">{s.emoji}</div>
            <div className={`text-xs font-semibold ${s.textClass}`}>{s.label}</div>
          </div>
        ))}
      </div>

      <p className="text-sm text-gray-500 mb-8">
        Takes about 5 minutes. You can update everything any time.
      </p>

      <button
        onClick={onNext}
        className="w-full bg-reset-terracotta text-white py-3 rounded-xl font-semibold text-sm hover:opacity-90 transition"
      >
        Build my reset path →
      </button>
    </div>
  );
}
